import { render, staticRenderFns } from "./WreDashboard.vue?vue&type=template&id=d172d998&"
import script from "./WreDashboard.vue?vue&type=script&lang=js&"
export * from "./WreDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports